import { useEffect, useState } from 'react';

import { SUPPORTED_TAILWIND_LAYOUT_SIZES, SupportedLayoutSize, getMediaQuery } from '@/helpers/getMediaQuery';

export const useMediaEffect = (cb?: (key: SupportedLayoutSize) => void) => {
  const [viewPort, setViewPort] = useState<SupportedLayoutSize>(SUPPORTED_TAILWIND_LAYOUT_SIZES[0]);

  useEffect(() => {
    const checkScreenSize = () => {
      for (const size of SUPPORTED_TAILWIND_LAYOUT_SIZES) {
        if (window.matchMedia(getMediaQuery(size)).matches) {
          cb?.(size);
          setViewPort(size);
        }
      }
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [cb]);

  return viewPort;
};
